import type { DepartmentsItem } from "@on-site/components/pages/directVisit/ui/departments/type";

import { DepartmentsPage } from "@on-site/components/pages/directVisit/ui/departments";
import { MedicalMenusPage } from "@on-site/components/pages/directVisit/ui/medicalMenus";
import { useState } from "react";
import { CheckInComplete } from "@on-site/components/pages/checkIn/ui/CheckInComplete";
import { PageLayout } from "@on-site/layouts/PageLayout";
import { useLocalViewsStore } from "@on-site/features/top/hooks/useLocalViewsStore";

export const DirectVisitPage = ({ patientNo }: { patientNo: string }) => {
  const { resetView } = useLocalViewsStore();

  const [isCompleted, setIsCompleted] = useState(false);
  const [department, setDepartment] = useState<DepartmentsItem | null>(null);

  if (isCompleted)
    return (
      <PageLayout>
        <CheckInComplete onStartOver={resetView} />
      </PageLayout>
    );

  if (department) {
    return (
      <MedicalMenusPage
        patientNo={patientNo}
        department={department}
        onRequestSuccess={() => setIsCompleted(true)}
        onGoBack={() => setDepartment(null)}
      />
    );
  }

  return <DepartmentsPage onSelectDepartment={setDepartment} />;
};
